import { render, staticRenderFns } from "./student.vue?vue&type=template&id=83765d40&scoped=true"
import script from "./student.vue?vue&type=script&lang=js"
export * from "./student.vue?vue&type=script&lang=js"
import style0 from "./student.vue?vue&type=style&index=0&id=83765d40&lang=scss&scoped=true"
import style1 from "./student.vue?vue&type=style&index=1&id=83765d40&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83765d40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83765d40')) {
      api.createRecord('83765d40', component.options)
    } else {
      api.reload('83765d40', component.options)
    }
    module.hot.accept("./student.vue?vue&type=template&id=83765d40&scoped=true", function () {
      api.rerender('83765d40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/student.vue"
export default component.exports